module.exports = __webpack_public_path__ + "img/colors.633591e7.png";